import { render, staticRenderFns } from "./FollowingProductionTableView.vue?vue&type=template&id=35779106&scoped=true&"
import script from "./FollowingProductionTableView.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionTableView.vue?vue&type=script&lang=js&"
import style0 from "./FollowingProductionTableView.vue?vue&type=style&index=0&id=35779106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35779106",
  null
  
)

export default component.exports